import { motion } from 'framer-motion'

interface Props {
  existingName: string
  onClaim: () => void
  onKeepNew: () => void
}

export default function SeatTakeoverPrompt({ existingName, onClaim, onKeepNew }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 z-50 bg-warmblack/40 backdrop-blur-sm flex items-center justify-center px-6"
    >
      <motion.div
        initial={{ scale: 0.9, y: 20 }}
        animate={{ scale: 1, y: 0 }}
        className="bg-cream rounded-2xl shadow-2xl max-w-sm w-full p-6 space-y-4"
      >
        <h2 className="font-display text-2xl font-bold text-warmblack">
          Welcome back?
        </h2>
        <p className="font-body text-base text-warmblack/80 leading-relaxed">
          <span className="font-bold">{existingName}</span> already joined this
          room. Did you previously play as them — for example on a different
          device — and want to take their spot back?
        </p>
        <p className="font-body text-sm text-warmblack/60">
          The host will need to approve. If you do this, you'll inherit
          {' '}{existingName}'s score and place in the round rotation.
        </p>
        <div className="flex flex-col gap-2 pt-1">
          <button
            onClick={onClaim}
            className="w-full bg-coral hover:bg-coral/90 text-white font-display font-bold py-3 rounded-xl shadow-sm transition-colors"
          >
            Yes, ask the host
          </button>
          <button
            onClick={onKeepNew}
            className="w-full bg-white hover:bg-warmblack/5 text-warmblack font-display font-bold py-3 rounded-xl border border-warmblack/10 transition-colors"
          >
            No, I'll change my name
          </button>
        </div>
      </motion.div>
    </motion.div>
  )
}
